/**
 * Checks if the question value contains at most one special fabric process.
 * Special processes are grouped by their type (e.g., all KNITTING processes are considered one type).
 * @param {string[]} params[0] - the question value to be checked
 * @param {string[]} params[1] - the list of special fabric processes
 * @returns {boolean} true if the question value contains at most one type of special fabric process, false otherwise
 */
function containsOnlyOneSpecialFabricProcess(params: any[]) {
  const questionValue = params[0] as string[];
  const specialFabricProcesses = params[1] as string[];

  if (!questionValue || !specialFabricProcesses) {
    return false;
  }

  // Group processes by their type (e.g., all KNITTING processes are one type)
  const processTypes = new Set<string>();

  questionValue.forEach((process: string) => {
    if (specialFabricProcesses.includes(process)) {
      // Extract the process type (e.g., KNITTING, MANUFACTURING, etc.)
      const processType = process.split("_").pop() || process;
      processTypes.add(processType);
    }
  });

  // Return true if we have at most one type of special process
  return processTypes.size <= 1;
}

export default containsOnlyOneSpecialFabricProcess;
